<div class="relative w-full h-40 sm:h-48 px-8 sm:px-12 bg-accent-100 dark:bg-accent-700">
    <ng-container>
        <img class="absolute inset-0 object-cover w-full h-full" [src]="image" (error)="errorHandler($event)">
    </ng-container>

    <div class="flex items-center justify-end w-full max-w-3xl mx-auto pt-6">
        <button class="bg-gray-800" mat-icon-button [matTooltip]="'Close'" (click)="navigateTo()">
            <fa-icon [icon]="['fal', 'times']" class="text-white icon-size-5"></fa-icon>
        </button>
    </div>

</div>
